/**
 * DevExtreme (ui/text_box.js)
 * Version: 16.2.5
 * Build date: Mon Feb 27 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 * EULA: https://www.devexpress.com/Support/EULAs/DevExtreme.xml
 */
"use strict";
module.exports = require("./text_box/text_box");
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/devextreme/ui/text_box.js
// module id = ../../../../devextreme/ui/text_box.js
// module chunks = 3